var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('element-list',{attrs:{"prevRoute":_vm.prevRoute,"latest":_vm.latest,"admin":_vm.admin}})}
var staticRenderFns = []

export { render, staticRenderFns }